// extracted by mini-css-extract-plugin
export default {"pricingRows":"style--pricingRows--3e919d","container":"style--container--9477ef","attention":"style--attention--516e34","servicePrices":"style--servicePrices--51a19f"};